import { ConnexionPageParameters } from "./ConnexionPageParameter";

/** Définition des transitions d'états réalisables */
export interface IConnexionPageState{
    /** Déclenche l'opération d'authentification */
    SignIn(): Promise<void>;
    /** Déclenche l'opération de mot de passe oublié */
    ResetPassword(): void;
    /** Analyse et valide la saisie du changement de mot de passe */
    SendMail(): Promise<void>;
    /** Déclenche l'opération de transfert vers la page d'acceuil (ConnexionPage ou Master)*/
    Abord(): Promise<void>;
    /** Ouvre le volet d'information sur l'application DCx */
    About(): void;
}

/** Base de tous les états ConnexionPage */
export abstract class ConnexionPageState implements IConnexionPageState{
    /** Context de la machine a état */
    protected context: ConnexionPageParameters;

    /** Constructeur de la machine a état */
    constructor(context: ConnexionPageParameters){
        this.context = context;
    }

    /** Déclenche l'opération d'authentification */
    public abstract SignIn(): Promise<void>;
    /** Déclenche l'opération de mot de passe oublié */
    public abstract ResetPassword(): void;
    /** Analyse et valide la saisie du changement de mot de passe */
    public abstract SendMail(): Promise<void>;
    /** Déclenche l'opération de transfert vers la page d'acceuil (ConnexionPage ou Master)*/
    public abstract Abord(): Promise<void>;
    /** Ouvre le volet d'information sur l'application DCx */
    public abstract About(): void;
}